import { z } from 'zod';
import { Gwei } from '../lib/gwei';

const BidAskSchema = z.tuple([
  z.string().transform(Gwei.toGwei), // price
  z.string().transform(Gwei.toGwei), // quantity
]);

export const BookDepthSchema = z.object({
  productId: z.string(),
  timestamp: z.number(),
  previousTimestamp: z.number().optional(),
  bids: z.array(BidAskSchema),
  asks: z.array(BidAskSchema),
});
export type BidAsk = z.infer<typeof BidAskSchema>;
export type BidsAsks = { bids: BidAsk[]; asks: BidAsk[] };
export type BookDepth = z.infer<typeof BookDepthSchema>;
